<template>
  <svg class="fill-current inline-block" viewBox="0 0 24 24"><path d="M23.245 4l-11.245 14.374-11.219-14.374-.781.619 12 15.381 12-15.391-.755-.609z" /></svg>
</template>
